/* eslint-disable @typescript-eslint/no-unsafe-function-type */

import { useAppStore } from '@stores';

class EventBus {
  listeners: { [key: string]: Function[] } = {};

  removeEventListener(type: string, listener: Function) {
    if (!this.listeners[type]) {
      return;
    }
    this.listeners[type] = this.listeners[type].filter((l) => l !== listener);
  }

  addEventListener(type: string, listener: Function) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(listener);
  }

  dispatchEvent(type: string, message: any) {
    if (!this.listeners[type]) {
      return;
    }
    this.listeners[type].forEach((listener) => listener(message));
  }

  removeEventTypes(type: string[]) {
    type.forEach((t) => {
      this.listeners[t] = [];
    });
  }
}

export const MobileAppBus = new EventBus();

export const initMobileAppBus = () => {
  const handleEvent = (message: any) => {
    MobileAppBus.dispatchEvent(message?.data?.type, message?.data?.message);

    if (message?.data?.type === 'deviceInfo') {
      useAppStore.getState().setDevice(message.data.message.platform);
    }
  };

  sendAppMessage('checkDevice');
  document.addEventListener('message', handleEvent);

  setTimeout(() => {
    sendAppMessage('finishedLoading');
  }, 2000);
};

export const sendAppMessage = (msg: string, data?: any) => {
  if (window.Android) {
    const dataString = typeof data === 'object' ? JSON.stringify(data) : data;
    window.Android.handleEvent(msg, dataString);
  }

  if (window.webkit) {
    const iosData = typeof data === 'object' ? data : { content: data };
    window.webkit.messageHandlers.observer.postMessage(JSON.stringify({ type: msg, message: iosData }));
  }
};
